export function initialState () {
  return {
  }
}

export default initialState()
